export const MedioContactoArray=[
    {id:'T',display:'TELEFONO'},
    {id:'W',display:'WHATSAPP'},
    {id:'C',display:'CORREO'},
]

export const MedioContactoClienteArray =[
    {id:'LL',display:'LLAMADA'},
    {id:'WH',display:'WHATSAPP'},
    {id:'CO',display:'CORREO'},
    {id:'VS',display:'VISITA'},
    {id:'MN',display:'MENSAJE'},
]